const getAdminToken = () => localStorage.getItem("adminToken");

const request = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      Authorization: `Bearer ${getAdminToken()}`,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok && response.status !== 207) {
    throw new Error(
      data.error ||
        data.message ||
        "Product import request failed"
    );
  }

  return {
    status: response.status,
    data,
  };
};

export const getEtikaImportProducts = async () => {
  const result = await request(
    "/api/admin/product-imports/etika/diagnostic"
  );

  return result.data;
};

export const importEtikaProducts = async (
  sourceProductIds
) => {
  return request(
    "/api/admin/product-imports/etika/import-bulk",
    {
      method: "POST",
      body: JSON.stringify({
        sourceProductIds,
      }),
    }
  );
};

export const syncEtikaImportCategories = async () => {
  return request(
    "/api/admin/product-imports/etika/categories/sync",
    {
      method: "POST",
      body: JSON.stringify({}),
    }
  );
};
